import { render, staticRenderFns } from "./SubscriptionForm.PurchaseOptionsForm.vue?vue&type=template&id=2b507f52&scoped=true&"
import script from "./SubscriptionForm.PurchaseOptionsForm.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.PurchaseOptionsForm.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.PurchaseOptionsForm.vue?vue&type=style&index=0&id=2b507f52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b507f52",
  null
  
)

export default component.exports